export * from "./click-prevent.directive";
